import { useSyncExternalStore } from 'react'
import { homeCommands } from '@/lib/cloud/store'

const STORAGE_KEY = 'norrvik-motion'

let paused = false
let initialised = false

const listeners = new Set<() => void>()

const apply = (): void => {
    if (typeof document === 'undefined') return

    document.documentElement.setAttribute('data-motion', paused ? 'paused' : 'running')
}

/**
 * One switch for all motion on the site: point clouds, the Home scene, arcs, skyline and CSS animations.
 */
export const motionStore = {
    get: (): boolean => paused,
    getServer: (): boolean => false,
    subscribe: (listener: () => void): (() => void) => {
        listeners.add(listener)

        return () => {
            listeners.delete(listener)
        }
    },
    set: (value: boolean): void => {
        paused = value
        apply()
        homeCommands.setPaused(value)

        try {
            window.localStorage.setItem(STORAGE_KEY, value ? 'paused' : 'running')
        }
        catch {
            // Storage can be unavailable in private modes.
        }

        listeners.forEach(listener => listener())
    },
    init: (): void => {
        if (initialised || typeof window === 'undefined') return

        initialised = true

        try {
            if (window.localStorage.getItem(STORAGE_KEY) === 'paused') {
                motionStore.set(true)

                return
            }
        }
        catch {
            // Storage can be unavailable in private modes.
        }

        apply()
    }
}

export const isMotionPaused = (): boolean => paused

export const useMotionPaused = (): boolean => useSyncExternalStore(motionStore.subscribe, motionStore.get, motionStore.getServer)
